export default __webpack_public_path__ + "static/media/household-4.2d050327.jpg";